const { get } = require( "@/utilities/querySelector" );


jQuery( function( $ ) {
    const form = /** @type {HTMLFormElement} */ ( document.querySelector( '.product form.cart' ) );
    if ( !form ) return;

    /**
     * If is pewced, we don't have to do anything in some cases.
     * nuwoo-pa-options is already compatible with pewc,
     * this means the extension-pewc already handles it.
     */
    const is_pewced = !!form.querySelector( '.pewc-product-extra-groups-wrap' );
    const options_price = document.getElementById( 'nuwoo-pa-options-price-total' );

    const priceFormatter = Intl.NumberFormat( 'en-GB', {
        style: 'currency',
        currency: NuWoo.settings.currency.code
    } );

    /**
     * Create a nice price display
     */
    if ( !is_pewced && options_price ) {
        form.addEventListener( 'nuwoo-pa-option-price-update', ( e ) => {
            const [excl_tax_el, incl_tax_el] = [
                get_price_excl_tax_element(),
                get_price_incl_tax_element()
            ];
            if ( !excl_tax_el || !incl_tax_el ) return;

            const excl_total = e.detail.productPrice.excl_tax + e.detail.optionsPrice.excl_tax;
            const incl_total = e.detail.productPrice.incl_tax + e.detail.optionsPrice.incl_tax;

            excl_tax_el.innerHTML = price_html( excl_total );
            incl_tax_el.innerHTML = price_html( incl_total );
        } );
    }

    /**
     * Update swatch price labels on label update for variation chosen
     */
    form.addEventListener( 'nuwoo-pa-option-label-update', ( e ) => {
        const input = e.target;

        if ( input.classList.contains( 'nu-swatch__input' ) ) {
            const displayPrice = e.detail.displayPrice;
            const option = e.detail.optionData;
            const swatch = input.closest( '.nu-swatch__item' );
            swatch.setAttribute( 'data-nuwoo-tooltip', `${option.name}${displayPrice ? ` + ${displayPrice}` : ''}` );
        }
    } );

    function get_price_incl_tax_element() {
        return get( '[data-price-incl-tax]', form );
    }

    function get_price_excl_tax_element() {
        return get( '[data-price-excl-tax]', form );
    }

    /**
     * @param {number} price
     *
     * @return {string}
     */
    function price_html( price ) {
        const currency = NuWoo.settings.currency.symbol;
        const display_price = format_price( price ).replace( currency, '' );
        return `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${currency}</span>${display_price}</bdi></span>`;
    }

    /**
     * Formats the number as the stores currency should be, based on the currency code
     *
     * @param {number} price
     *
     * @return {string}
     */
    function format_price( price ) {
        if ( price === 0 ) return '';
        return priceFormatter.format( price );
    }
} );